import { UserJob } from './userjob';

export class UserJobStatusResponse {
    public sessionValid!: boolean;
    public errorCode!: string;
    public errorMessage!: string;
    public errorMessageData!: number;
    public resultSize!: number;
    public resultPage!: number;
    public resultCount!: number;
    public userJobs: UserJob[] = [];
}